"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNITS = void 0;
// COLOR REGEX HELPERS
var integer = "\\d{1,3}";
var percentageNumber = "(\\d{1}(\\.\\d+)?|\\.\\d+)";
var percentage = "(\\d{1,3}(\\.\\d+)?|\\.\\d+)\\%";
var hex = "#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})";
var rgb = "rgb\\(" + integer + ",\\s*" + integer + ",\\s*" + integer + "\\)";
var rgba = "rgba\\(" + integer + ",\\s*" + integer + ",\\s*" + integer + ",\\s*" + percentageNumber + "\\)";
var hsl = "hsl\\(" + integer + ",\\s*" + percentage + ",\\s*" + percentage + "\\)";
var hsla = "hsla\\(" + integer + ",\\s*" + percentage + ",\\s*" + percentage + ",\\s*" + percentageNumber + "\\)";
var named = "transparent|aliceblue|antiquewhite|aqua|aquamarine|azure|beige|bisque|black|blanchedalmond|blue|blueviolet|brown|burlywood|cadetblue|chartreuse|chocolate|coral|cornflowerblue|cornsilk|crimson|cyan|darkblue|darkcyan|darkgoldenrod|darkgray|darkgrey|darkgreen|darkkhaki|darkmagenta|darkolivegreen|darkorange|darkorchid|darkred|darksalmon|darkseagreen|darkslateblue|darkslategray|darkslategrey|darkturquoise|darkviolet|deeppink|deepskyblue|dimgray|dimgrey|dodgerblue|firebrick|floralwhite|forestgreen|fuchsia|gainsboro|ghostwhite|gold|goldenrod|gray|grey|green|greenyellow|honeydew|hotpink|indianred|indigo|ivory|khaki|lavender|lavenderblush|lawngreen|lemonchiffon|lightblue|lightcoral|lightcyan|lightgoldenrodyellow|lightgray|lightgrey|lightgreen|lightpink|lightsalmon|lightseagreen|lightskyblue|lightslategray|lightslategrey|lightsteelblue|lightyellow|lime|limegreen|linen|magenta|maroon|mediumaquamarine|mediumblue|mediumorchid|mediumpurple|mediumseagreen|mediumslateblue|mediumspringgreen|mediumturquoise|mediumvioletred|midnightblue|mintcream|mistyrose|moccasin|navajowhite|navy|oldlace|olive|olivedrab|orange|orangered|orchid|palegoldenrod|palegreen|paleturquoise|palevioletred|papayawhip|peachpuff|peru|pink|plum|powderblue|purple|red|rosybrown|royalblue|saddlebrown|salmon|sandybrown|seagreen|seashell|sienna|silver|skyblue|slateblue|slategray|slategrey|snow|springgreen|steelblue|tan|teal|thistle|tomato|turquoise|violet|wheat|white|whitesmoke|yellow|yellowgreen";
var COLOR = {
    type: 'String',
    pattern: "^" + hex + "|" + rgb + "|" + rgba + "|" + hsl + "|" + hsla + "|" + named + "$"
};
var MEASURE = {
    type: 'String',
    pattern: "^-?\\d+(\\.\\d)?(cm|mm|in|pc|pt|px|em|ex|ch|rem|lh|vw|vh|vmin|vmax|%)$"
};
var PADDING = {
    type: 'Object',
    properties: {
        top: __assign(__assign({}, MEASURE), { required: false }),
        right: __assign(__assign({}, MEASURE), { required: false }),
        bottom: __assign(__assign({}, MEASURE), { required: false }),
        left: __assign(__assign({}, MEASURE), { required: false })
    }
};
var FONT = {
    type: 'Object',
    properties: {
        size: MEASURE,
        family: { type: 'String' },
        style: { type: 'String', default: 'normal', options: ['normal', 'italic', 'oblique'] },
        weight: { type: 'Number', default: 400, options: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
        align: { type: 'String', required: false, options: ['left', 'right', 'center'] },
        lineHeight: __assign(__assign({}, MEASURE), { required: false }),
        letterSpacing: __assign(__assign({}, MEASURE), { required: false }),
        transform: {
            type: 'String',
            required: false,
            options: ['none', 'capitalize', 'uppercase', 'lowercase', 'full-width']
        }
    }
};
var BORDER = {
    type: 'Object',
    properties: {
        width: __assign(__assign({}, MEASURE), { required: false }),
        style: {
            type: 'Object',
            required: false,
            properties: {
                top: { type: 'String', required: false, options: ['none', 'dotted', 'dashed', 'solid'] },
                bottom: { type: 'String', required: false, options: ['none', 'dotted', 'dashed', 'solid'] },
                left: { type: 'String', required: false, options: ['none', 'dotted', 'dashed', 'solid'] },
                right: { type: 'String', required: false, options: ['none', 'dotted', 'dashed', 'solid'] }
            }
        },
        radius: {
            type: 'Object',
            required: false,
            properties: {
                topRight: __assign(__assign({}, MEASURE), { required: false }),
                topLeft: __assign(__assign({}, MEASURE), { required: false }),
                bottomRight: __assign(__assign({}, MEASURE), { required: false }),
                bottomLeft: __assign(__assign({}, MEASURE), { required: false })
            }
        }
    }
};
var SHADOW = {
    type: 'Object',
    properties: {
        inset: { type: 'Boolean', required: false },
        x: MEASURE,
        y: MEASURE,
        blur: MEASURE,
        spread: MEASURE,
        color: COLOR
    }
};
var OUTLINE = {
    type: 'Object',
    properties: {
        width: MEASURE,
        offset: __assign(__assign({}, MEASURE), { default: '0px' }),
        style: { type: 'String', default: 'solid', options: ['none', 'dotted', 'dashed', 'solid'] }
    }
};
exports.UNITS = {
    COLOR: __assign(__assign({}, COLOR), { asOptional: function () { return (__assign(__assign({}, COLOR), { required: false })); }, defaultTo: function (color) { return (__assign(__assign({}, COLOR), { default: color })); } }),
    MEASURE: __assign(__assign({}, MEASURE), { asOptional: function () { return (__assign(__assign({}, MEASURE), { required: false })); }, defaultTo: function (measure) { return (__assign(__assign({}, MEASURE), { default: measure })); } }),
    SHADOW: __assign(__assign({}, SHADOW), { asOptional: function () { return (__assign(__assign({}, SHADOW), { required: false })); }, defaultTo: function (_a) {
            var inset = _a.inset, x = _a.x, y = _a.y, blur = _a.blur, spread = _a.spread, color = _a.color;
            return (__assign(__assign({}, SHADOW), { properties: {
                    inset: { type: 'Boolean', default: inset },
                    x: __assign(__assign({}, MEASURE), { default: x }),
                    y: __assign(__assign({}, MEASURE), { default: y }),
                    blur: __assign(__assign({}, MEASURE), { default: blur }),
                    spread: __assign(__assign({}, MEASURE), { default: spread }),
                    color: __assign(__assign({}, COLOR), { default: color })
                } }));
        } }),
    BORDER: __assign(__assign({}, BORDER), { asOptional: function () { return (__assign(__assign({}, BORDER), { required: false })); }, defaultTo: function (_a) {
            var width = _a.width, style = _a.style, radius = _a.radius;
            return (__assign(__assign({}, BORDER), { width: __assign(__assign({}, BORDER.properties.width), { default: width }), style: __assign(__assign({}, BORDER.properties.style), { type: 'String', default: style }), radius: __assign(__assign({}, BORDER.properties.radius), { default: radius }) }));
        } }),
    OUTLINE: __assign(__assign({}, OUTLINE), { asOptional: function () { return (__assign(__assign({}, OUTLINE), { required: false })); }, defaultTo: function (_a) {
            var width = _a.width, offset = _a.offset, style = _a.style;
            return (__assign(__assign({}, OUTLINE), { width: __assign(__assign({}, OUTLINE.properties.width), { default: width }), offset: __assign(__assign({}, OUTLINE.properties.offset), { default: offset }), style: __assign(__assign({}, OUTLINE.properties.style), { default: style }) }));
        } }),
    PADDING: __assign(__assign({}, PADDING), { asOptional: function () { return (__assign(__assign({}, PADDING), { required: false })); }, defaultTo: function (_a) {
            var top = _a.top, bottom = _a.bottom, left = _a.left, right = _a.right;
            return ({
                type: 'Object',
                default: {},
                properties: {
                    type: { type: 'String', options: ['padding'], default: 'padding' },
                    top: __assign(__assign({}, MEASURE), { default: top }),
                    right: __assign(__assign({}, MEASURE), { default: right }),
                    bottom: __assign(__assign({}, MEASURE), { default: bottom }),
                    left: __assign(__assign({}, MEASURE), { default: left })
                }
            });
        } }),
    FONT: __assign(__assign({}, FONT), { asOptional: function () { return (__assign(__assign({}, FONT), { required: false })); }, defaultTo: function (_a) {
            var size = _a.size, family = _a.family, style = _a.style, weight = _a.weight, lineHeight = _a.lineHeight, letterSpacing = _a.letterSpacing, transform = _a.transform;
            return (__assign(__assign({}, FONT), { default: {}, properties: {
                    size: __assign(__assign({}, FONT.properties.size), { default: size }),
                    family: __assign(__assign({}, FONT.properties.family), { default: family }),
                    style: __assign(__assign({}, FONT.properties.style), { default: style !== null && style !== void 0 ? style : 'normal' }),
                    weight: __assign(__assign({}, FONT.properties.weight), { default: weight !== null && weight !== void 0 ? weight : 'normal' }),
                    lineHeight: __assign(__assign({}, FONT.properties.lineHeight), { default: lineHeight !== null && lineHeight !== void 0 ? lineHeight : '100%' }),
                    letterSpacing: __assign(__assign({}, FONT.properties.letterSpacing), { default: letterSpacing !== null && letterSpacing !== void 0 ? letterSpacing : 'normal' }),
                    transform: __assign(__assign({}, FONT.properties.transform), { default: transform !== null && transform !== void 0 ? transform : 'none' })
                } }));
        } })
};
